import { cn } from '@seen/ui'
import type { HTMLAttributes, JSX } from 'react'

export type DialogFooterProps = HTMLAttributes<HTMLDivElement>

export function DialogFooter({
  className,
  ...delegated
}: DialogFooterProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex flex-col-reverse p-6 sm:flex-row sm:justify-end sm:gap-4',
        className
      )}
      {...delegated}
    />
  )
}
